import clsx from "clsx";
import { uniq } from "lodash";

import { CopyButton } from "@components/shared/buttons";
import { getNorthbeamUtmPlatformParams } from "@features/utm-guide";

const EXCLUSION_PARAMS = uniq(
  getNorthbeamUtmPlatformParams()
    .map((pm) => pm.key)
    .filter((k) => !k.startsWith("utm_")),
)
  .sort()
  .join(",");

export const GaParameterExclusionsTextArea = (props: {
  className?: string;
}) => {
  return (
    <div
      {...props}
      className={clsx(
        "ga-parameter-exclusions-text-area",
        "flex",
        "flex-col",
        "gap-3",
        props.className,
      )}
    >
      <textarea
        className="form-control"
        value={EXCLUSION_PARAMS}
        rows={6}
        readOnly
      />
      <CopyButton
        valueToCopy={EXCLUSION_PARAMS}
        variant="primary"
        style={{ maxWidth: "fit-content" }}
      >
        COPY
      </CopyButton>
    </div>
  );
};
